import styled from 'styled-components';

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <StyledFooter>
            &copy; {currentYear} All Rights Reserved. Dentaprime.
        </StyledFooter>
    );
};

const StyledFooter = styled.footer`
    padding: 10px 46px 20px 46px;
    color: var(--footer-text-color);
    font-family: Myriad Pro;
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: -0.1px;
    background: var(--footer-bg);

    @media (max-width: 768px) {
        padding: 0 20px 10px;
    }
`;
